import { render } from "./ConnectorCarousel.vue?vue&type=template&id=08a9245e&scoped=true&ts=true"
import script from "./ConnectorCarousel.vue?vue&type=script&lang=ts"
export * from "./ConnectorCarousel.vue?vue&type=script&lang=ts"

import "./ConnectorCarousel.vue?vue&type=style&index=0&id=08a9245e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9245e"]])

export default __exports__